import October1 from '@/assets/images/newsletters/October-us-1.png';
import October2 from '@/assets/images/newsletters/October-us-2.png';
import October3 from '@/assets/images/newsletters/October-us-3.png';
import October4 from '@/assets/images/newsletters/October-us-4.png';
import October5 from '@/assets/images/newsletters/October-us-5.png';
import November1 from '@/assets/images/newsletters/November-us-1.png';
import November2 from '@/assets/images/newsletters/November-us-2.png';
import November3 from '@/assets/images/newsletters/November-us-3.png';
import November4 from '@/assets/images/newsletters/November-us-4.png';
import November5 from '@/assets/images/newsletters/November-us-5.png';
import December1 from '@/assets/images/newsletters/December-us-1.png';
import December2 from '@/assets/images/newsletters/December-us-2.png';
import December3 from '@/assets/images/newsletters/December-us-3.png';
import December4 from '@/assets/images/newsletters/December-us-4.png';
import December5 from '@/assets/images/newsletters/December-us-5.png';
import January1 from '@/assets/images/newsletters/January-us-1.png';
import January2 from '@/assets/images/newsletters/January-us-2.png';
import January3 from '@/assets/images/newsletters/January-us-3.png';
import January4 from '@/assets/images/newsletters/January-us-4.png';
import January5 from '@/assets/images/newsletters/January-us-5.png';

export default {
    newsletters: [
        // {
        //     title: "4 Ways to Prepare for Homeownership and Unexepected Repairs",
        //     subtitle: "US Newsletter or Blog",
        //     type: "October",
        //     region: "USA",
        //     thumbnail: October1,
        //     url: "https://www.canva.com/design/DAGUHWOI_aQ/L_pHr9RU_Cl0hKdeTUnQiw/view?utm_content=DAGUHWOI_aQ&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        // {
        //     title: "3 Hacks to Sell Your Home Faster and for Top Dollar",
        //     subtitle: "US Newsletter or Blog",
        //     type: "October",
        //     region: "USA",
        //     thumbnail: October2,
        //     url: "https://www.canva.com/design/DAGUHcFIiGQ/UE1ZF3SYedn7WhQ83txB_A/view?utm_content=DAGUHcFIiGQ&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        // {
        //     title: "5 Reasons New Construction Homes are More Than Just Brand New",
        //     subtitle: "US Newsletter or Blog",
        //     type: "October",
        //     region: "USA",
        //     thumbnail: October3,
        //     url: "https://www.canva.com/design/DAGUHUZpDJw/q4Olxz8V-n5FgS_r4xnPZw/view?utm_content=DAGUHUZpDJw&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        // {
        //     title: "Streamline Your Selling Process: 5 Tips for Reducing Showings",
        //     subtitle: "US Newsletter or Blog",
        //     type: "October",
        //     region: "USA",
        //     thumbnail: October4,
        //     url: "https://www.canva.com/design/DAGUHT9uMBk/xka36abNgvQpTvW4ElUfeA/view?utm_content=DAGUHT9uMBk&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        // {
        //     title: "Avoid Costly Repairs with These 3 Seasonal Home Checkup Tips",
        //     subtitle: "US Newsletter or Blog",
        //     type: "October",
        //     region: "USA",
        //     thumbnail: October5,
        //     url: "https://www.canva.com/design/DAGUHWpZulQ/_WrDvG_BtQJJZ1rdplO9sA/view?utm_content=DAGUHWpZulQ&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        
        
        // {
        //     
        // }

        {
            title: "Is 2025 the Year You Make Your Homeownership Dreams Happen?",
            subtitle: "US Newsletter or Blog",
            type: "January",
            region: "USA",
            thumbnail: January1,
            url: "https://www.canva.com/design/DAGZMzBUj7U/kEhbg_i3C99KIKhsk6HCPg/view?utm_content=DAGZMzBUj7U&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "Decluttering 101: How to Prep Your Home for the Market",
            subtitle: "US Newsletter or Blog",
            type: "January",
            region: "USA",
            thumbnail: January2,
            url: "https://www.canva.com/design/DAGZMyKIBTA/fP1LH6L42KgV9gB9BNZzLw/view?utm_content=DAGZMyKIBTA&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "1 Tip to Become the Most Organized Homeowner in 2025",
            subtitle: "US Newsletter or Blog",
            type: "January",
            region: "USA",
            thumbnail: January3,
            url: "https://www.canva.com/design/DAGZMwlD8So/zZZZjU7vJabDwzXvzlV3YA/view?utm_content=DAGZMwlD8So&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "4 Reasons New Construction Makes Sense for Families",
            subtitle: "US Newsletter or Blog",
            type: "January",
            region: "USA",
            thumbnail: January4,
            url: "https://www.canva.com/design/DAGZM3UIlTQ/c1e6LqI-htKVL291JOIDdQ/view?utm_content=DAGZM3UIlTQ&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "10 Questions to Ask Your Partner BEFORE House Hunting",
            subtitle: "US Newsletter or Blog",
            type: "January",
            region: "USA",
            thumbnail: January5,
            url: "https://www.canva.com/design/DAGZM78SWd0/fe2Cu0mW82tnKj-FCnZBZg/view?utm_content=DAGZM78SWd0&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "3 Reasons You Should Buy a Home This Winter",
            subtitle: "US Newsletter or Blog",
            type: "December",
            region: "USA",
            thumbnail: December1,
            url: "https://www.canva.com/design/DAGWkltaRB4/aLyOEIGxjYZ-q44zWcWb6w/view?utm_content=DAGWkltaRB4&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "Hosting Hacks: 6 Tips for a Stress-Free Holiday Season",
            subtitle: "US Newsletter or Blog",
            type: "December",
            region: "USA",
            thumbnail: December2,
            url: "https://www.canva.com/design/DAGWkmvYetc/NqxeI5OCtrquKeoLhQJL-g/view?utm_content=DAGWkmvYetc&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "How to Qualify for MORE Money to Buy Your Home",
            subtitle: "US Newsletter or Blog",
            type: "December",
            region: "USA",
            thumbnail: December3,
            url: "https://www.canva.com/design/DAGWkk9w4gI/neK_yNtdiqrbUtghaLxp1g/view?utm_content=DAGWkk9w4gI&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "Winterize Your Home: A Home Maintenance Checklist for a Cozy Season",
            subtitle: "US Newsletter or Blog",
            type: "December",
            region: "USA",
            thumbnail: December4,
            url: "https://www.canva.com/design/DAGWkuEwaHM/TvhPlk8t3XKhVHEjMHo5-Q/view?utm_content=DAGWkuEwaHM&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "The Biggest Reason Why Purchase Contracts Fall Through",
            subtitle: "US Newsletter or Blog",
            type: "December",
            region: "USA",
            thumbnail: December5,
            url: "https://www.canva.com/design/DAGWkgdGD7g/q317OLcWFYvAEdM25grJdg/view?utm_content=DAGWkgdGD7g&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        /*new month*/
        {
            title: "How to Prepare Your Home for Listing Photos",
            subtitle: "US Newsletter or Blog",
            type: "November",
            region: "USA",
            thumbnail: November1,
            url: "https://www.canva.com/design/DAGUHfRCy5E/Ln5R-AjgiLjNfEMMBgZr3g/view?utm_content=DAGUHfRCy5E&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "Your Guide to Finding Hidden Real Estate Gems",
            subtitle: "US Newsletter or Blog",
            type: "November",
            region: "USA",
            thumbnail: November2,
            url: "https://www.canva.com/design/DAGUHpaCSz0/mYXAY89KMqNP86KAzM-AVQ/view?utm_content=DAGUHpaCSz0&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "What You Need to Know about the 2025 Real Estate Market",
            subtitle: "US Newsletter or Blog",
            type: "November",
            region: "USA",
            thumbnail: November3,
            url: "https://www.canva.com/design/DAGUHSHDBMQ/IAx2e0sdiZSLeFZR571jiQ/view?utm_content=DAGUHSHDBMQ&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "3 Key Factors that Make or Break Your Mortgage Application",
            subtitle: "US Newsletter or Blog",
            type: "November",
            region: "USA",
            thumbnail: November4,
            url: "https://www.canva.com/design/DAGUHaBHFwI/UvWC8T4lNlaYw5G5NtZIBQ/view?utm_content=DAGUHaBHFwI&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "This Season’s Biggest Question: Celebrate Big or Save Big?",
            subtitle: "US Newsletter or Blog",
            type: "November",
            region: "USA",
            thumbnail: November5,
            url: "https://www.canva.com/design/DAGUHfHA89w/uk3BCrJC7O_vDAceGdufpQ/view?utm_content=DAGUHfHA89w&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        /* New Month */
        
        /*Canada*/
        // {
        //     title: "4 Ways to Prepare for Homeownership and Unexepected Repairs",
        //     subtitle: "Canada Newsletter or Blog",
        //     type: "October",
        //     region: "Canada",
        //     thumbnail: October1,
        //     url: "https://www.canva.com/design/DAGUHePD-Ac/iACX0UZegNm0Z9H2A5Ay6A/view?utm_content=DAGUHePD-Ac&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        // {
        //     title: "3 Hacks to Sell Your Home Faster and for Top Dollar",
        //     subtitle: "Canada Newsletter or Blog",
        //     type: "October",
        //     region: "Canada",
        //     thumbnail: October2,
        //     url: "https://www.canva.com/design/DAGUHUESlk8/ML9kgYwHjspbL5QllYIsMQ/view?utm_content=DAGUHUESlk8&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        // {
        //     title: "5 Reasons New Construction Homes are More Than Just Brand New",
        //     subtitle: "Canada Newsletter or Blog",
        //     type: "October",
        //     region: "Canada",
        //     thumbnail: October3,
        //     url: "https://www.canva.com/design/DAGUHV4d4dY/P5DCbWF5nvJKSl4hAFmg9g/view?utm_content=DAGUHV4d4dY&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        // {
        //     title: "Streamline Your Selling Process: 5 Tips for Reducing Showings",
        //     subtitle: "Canada Newsletter or Blog",
        //     type: "October",
        //     region: "Canada",
        //     thumbnail: October4,
        //     url: "https://www.canva.com/design/DAGUHZnAP5g/AdzGu-eLl3BuiWdvPUbDUg/view?utm_content=DAGUHZnAP5g&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        // {
        //     title: "Avoid Costly Repairs with These 3 Seasonal Home Checkup Tips",
        //     subtitle: "Canada Newsletter or Blog",
        //     type: "October",
        //     region: "Canada",
        //     thumbnail: October5,
        //     url: "https://www.canva.com/design/DAGT-SYSfVM/eDiSZqf49LbfD1pFBkh0ow/view?utm_content=DAGT-SYSfVM&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        // },
        {
            title: "Is 2025 the Year You Make Your Homeownership Dreams Happen?",
            subtitle: "Canada Newsletter or Blog",
            type: "January",
            region: "Canada",
            thumbnail: January1,
            url: "https://www.canva.com/design/DAGZM8JwjPM/GHQlFINN8vH4VtkbegNGJA/view?utm_content=DAGZM8JwjPM&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "Decluttering 101: How to Prep Your Home for the Market",
            subtitle: "Canada Newsletter or Blog",
            type: "January",
            region: "Canada",
            thumbnail: January2,
            url: "https://www.canva.com/design/DAGZM0u0jcc/nWs3uFCmY5rAQBcDPsDzUg/view?utm_content=DAGZM0u0jcc&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "1 Tip to Become the Most Organized Homeowner in 2025",
            subtitle: "Canada Newsletter or Blog",
            type: "January",
            region: "Canada",
            thumbnail: January3,
            url: "https://www.canva.com/design/DAGZM1qXY3w/S8hjqU3-Qlqr6WtZA6lAcA/view?utm_content=DAGZM1qXY3w&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "4 Reasons New Construction Makes Sense for Families",
            subtitle: "Canada Newsletter or Blog",
            type: "January",
            region: "Canada",
            thumbnail: January4,
            url: "https://www.canva.com/design/DAGZM68TXzQ/gqikQpEZSFNcJq9GzakDZQ/view?utm_content=DAGZM68TXzQ&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "10 Questions to Ask Your Partner BEFORE House Hunting",
            subtitle: "Canada Newsletter or Blog",
            type: "January",
            region: "Canada",
            thumbnail: January5,
            url: "https://www.canva.com/design/DAGZMy0iaco/hTLbUlmixU5_b3hrcvqiIw/view?utm_content=DAGZMy0iaco&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        /*new month*/
        {
            title: "How to Prepare Your Home for Listing Photos",
            subtitle: "Canada Newsletter or Blog",
            type: "November",
            region: "Canada",
            thumbnail: November1,
            url: "https://www.canva.com/design/DAGUHcGecGE/OUkqTKvsU2AQJ6B4_e-ztw/view?utm_content=DAGUHcGecGE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "Your Guide to Finding Hidden Real Estate Gems",
            subtitle: "Canada Newsletter or Blog",
            type: "November",
            region: "Canada",
            thumbnail: November2,
            url: "https://www.canva.com/design/DAGUHUEx9ME/OEhyZH_DZ1WRP5iglyasIA/view?utm_content=DAGUHUEx9ME&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "What You Need to Know about the 2025 Real Estate Market",
            subtitle: "Canada Newsletter or Blog",
            type: "November",
            region: "Canada",
            thumbnail: November3,
            url: "https://www.canva.com/design/DAGUHXa_UUo/4y_25IIiFbGHraPVoFchSw/view?utm_content=DAGUHXa_UUo&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "3 Key Factors that Make or Break Your Mortgage Application",
            subtitle: "Canada Newsletter or Blog",
            type: "November",
            region: "Canada",
            thumbnail: November4,
            url: "https://www.canva.com/design/DAGUHbCiDUA/fdzfQKue-pc_QjrxNiE_sQ/view?utm_content=DAGUHbCiDUA&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "This Season’s Biggest Question: Celebrate Big or Save Big?",
            subtitle: "Canada Newsletter or Blog",
            type: "November",
            region: "Canada",
            thumbnail: November5,
            url: "https://www.canva.com/design/DAGUHc6-rMI/Ougpfa_tdCicxmjCad0EKQ/view?utm_content=DAGUHc6-rMI&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        /* New Month */
        {
            title: "3 Reasons You Should Buy a Home This Winter",
            subtitle: "Canada Newsletter or Blog",
            type: "December",
            region: "Canada",
            thumbnail: October1,
            url: "https://www.canva.com/design/DAGWksBxU3M/WnrXrnCRezdhZXrWimlJgA/view?utm_content=DAGWksBxU3M&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "Hosting Hacks: 6 Tips for a Stress-Free Holiday Season",
            subtitle: "Canada Newsletter or Blog",
            type: "December",
            region: "Canada",
            thumbnail: October2,
            url: "https://www.canva.com/design/DAGWksHitXY/YpLxfC4SJlaqUHSmJXRMIw/view?utm_content=DAGWksHitXY&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "How to Qualify for MORE Money to Buy Your Home",
            subtitle: "Canada Newsletter or Blog",
            type: "December",
            region: "Canada",
            thumbnail: October3,
            url: "https://www.canva.com/design/DAGWkiV650Y/Um2Uuk2WVt7YT1WhufbvPA/view?utm_content=DAGWkiV650Y&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "Winterize Your Home: A Home Maintenance Checklist for a Cozy Season",
            subtitle: "Canada Newsletter or Blog",
            type: "December",
            region: "Canada",
            thumbnail: October4,
            url: "https://www.canva.com/design/DAGWk2cgDpU/9COrCqR-Ge9tjXWdsopNrw/view?utm_content=DAGWk2cgDpU&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
        {
            title: "The Biggest Reason Why Purchase Contracts Fall Through",
            subtitle: "Canada Newsletter or Blog",
            type: "December",
            region: "Canada",
            thumbnail: October5,
            url: "https://www.canva.com/design/DAGWk_bDVKs/DlWMfiwzN9mTAqQSoRbGKQ/view?utm_content=DAGWk_bDVKs&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview"
        },
    ]
};

